<main class="c-main" role="main">
    <div class="c-page-policyresults">
        <div class="container">
            <div class="row mobile--orange u-pt60 u-pb30">
                <div class="col-md-12">
                    <h2 class="o-title" style="text-align: center;">{{'PolicyDetailPortal.title'| translate}} </h2>
                </div>
            </div>
        </div>
        <section class="c-results">
            <div *ngIf="data" class="container u-pt40 u-pb60">
                <div class="row">
                    <div class="col-md-10 col-md-offset-1">
                    <!-- Subtitle change depending on the state -->
                        <!-- Pending -->
                        <h2 class="o-title o-title--medium o-title--center js-txt2" *ngIf="data.status=='Pending'">{{'PolicyDetailPortal.statusPending' | translate}}</h2>

                        <!-- Approved -->
                        <h2 class="o-title o-title--medium o-title--center js-txt2" *ngIf="data.status=='Approved'">{{'PolicyDetailPortal.statusApproved' | translate}}</h2>

                        <!-- Reject -->
                        <h2 class="o-title o-title--medium o-title--center js-txt2" *ngIf="data.status=='Reject'">{{'PolicyDetailPortal.statusReject' | translate}}</h2>

                        <!-- Scaled -->
                        <h2 class="o-title o-title--medium o-title--center js-txt2" *ngIf="data.status=='Scaled'">{{'PolicyDetailPortal.statusScaled' | translate}}</h2>

                        <div class="o-steps">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row" *ngIf="data">
                                        <div class="col-xs-6 o-steps__step o-steps__step--approved">
                                            <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                                            <label class="js-txt3">{{ 'PolicyDetailPortal.labelStep1' | translate}}</label>
                                            <p class="js-txt4">{{'PolicyDetailPortal.labelSubmit' | translate}}</p>
                                        </div>
                                        
                                        <!-- Pending -->
                                        <div class="col-xs-6 o-steps__step " *ngIf="data.status=='Pending'" >
                                            <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                                            <label class="js-txt5">{{'PolicyDetailPortal.labelStep2' | translate}}</label>
                                           <!-- <p > {{ data[0].status }}</p>-->
                                            <p class="js-txt6">{{ 'PolicyDetailPortal.labelPending' | translate}}</p>
                                        </div>

                                        <!-- Approved -->
                                        <div class="col-xs-6 o-steps__step o-steps__step--approved" *ngIf="data.status=='Approved'">
                                            <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                                            <label class="js-txt3">{{ 'PolicyDetailPortal.labelStep2' | translate}}</label>
                                            <p class="js-txt4">{{'PolicyDetailPortal.labelApproved' | translate}}</p>
                                        </div>

                                        <!-- Reject -->
                                        <div class="col-xs-6 o-steps__step o-steps__step--rejected" *ngIf="data.status=='Reject'">
                                            <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                                            <label class="js-txt5">{{'PolicyDetailPortal.labelStep2' | translate}}</label>
                                            <p class="js-txt6">{{ 'PolicyDetailPortal.labelReject' | translate}}</p>
                                        </div>

                                        <!-- Scaled -->
                                        <div class="col-xs-6 o-steps__step " *ngIf="data.status=='Scaled'">
                                            <div class="o-steps__circle" style="background-color: coral;">
                                                <i class="icon icon-arrow" style=" transform: rotateY(180deg);"> </i>
                                            </div>
                                            <label class="js-txt5">{{'PolicyDetailPortal.labelStep2' | translate}}</label>
                                            <p class="js-txt6">{{ 'PolicyDetailPortal.labelScaled' | translate}}</p>
                                        </div>


                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="row">
                                <div class="col-md-10 col-md-offset-1">
                                   
                                    <div  class="u-pt40 u-pb30 u-mb40 center c-results__box">
                                            <h3><span >{{'PolicyDetailPortal.labelType' | translate}} : </span></h3>
                                            <p *ngIf="getlang()==='en'">{{data.typeEnNames | titlecase}}</p>
                                            <p *ngIf="getlang()==='es'">{{data.typeEsNames | titlecase}}</p>
                                    </div>                                        
                            
                                    <div class="u-pt40 u-pb30 u-mb40 center c-results__box" >
                                        
                                        <h3><span >{{'PolicyDetailPortal.labelRequestNumber' | translate}} : </span> {{id}}</h3>
                                        <p>{{'PolicyDetailPortal.replyMail' | translate}}</p>
                                        <p>{{'PolicyDetailPortal.sentMail' | translate}}</p>
                                    
                                        
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <p class="o-text o-text--big center js-txt14">{{'PolicyDetailPortal.trackLink' | translate}}</p>
                        <div class="row u-pt20">
                            
                            <div class="col-md-6 col-md-offset-3">
 
                                <a *ngIf="mode==='request'" class="btn btn--full btn--primary" [routerLink]="['/policy/list']">
                                    {{'PolicyDetailPortal.btnReqRecords' | translate}}</a>
                                <a *ngIf="mode==='approved'" class="btn btn--full btn--primary" [routerLink]="['/approver/list']">
                                    {{'PolicyDetailPortal.btnReqRecords' | translate}}</a>
                                
                            </div>
                                
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</main>